





















import Vue from "vue"
import {RunnerInfo} from "../lib/runner-utils";
import RunnerSummary from './RunnerSummary.vue'
import request from "../lib/request";

export default Vue.extend({
  data() {
    return {
      runners: <RunnerInfo[]>[]
    }
  },

  components: {
    RunnerSummary
  },

  created() {
    this.fetchData()
  },

  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData() {
      request.getRunners()
        .then(items => {
          this.runners = items
        })
    }
  }
})




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Runners.vue